<div class="button">
    <div class="buttonAction">
        <ix-icon class="icon" name="about" size="24" (click)="openModal()"></ix-icon>
    </div>
</div>